import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "",
    component: HomeView,
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/:category/:id",
    name: "\u2015 I am Product",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/ProductView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/login",
    name: "\u2015 Log-in",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/RegisterView.vue"),
  },
  {
    path: "/recover-password",
    name: "Recover Password",
    component: () =>
      import(
        /* webpackChunkName: "recover password" */ "../views/RecoverPasswordView.vue"
      ),
  },
  {
    path: "/about",
    name: "\u2015 About Us",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/shop",
    name: "\u2015 Shop",
    component: () =>
      import(/* webpackChunkName: "shop" */ "../views/ShopView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/furniture",
    name: "\u2015 Furniture",
    component: () =>
      import(/* webpackChunkName: "furniture" */ "../views/FurnitureView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/lighting",
    name: "\u2015 Lighting",
    component: () =>
      import(/* webpackChunkName: "lighting" */ "../views/LightingView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/rug",
    name: "\u2015 Rug",
    component: () =>
      import(/* webpackChunkName: "rug" */ "../views/RugView.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/cart",
    name: "\u2015 Cart",
    component: () =>
      import(/* webpackChunkName: "cart" */ "../views/CartView.vue"),
    meta: {
      authRequired: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = "Home Décor " + to.name;
  const authRequired = to.matched.some((route) => route.meta.authRequired);
  if (!authRequired) return next();
  if (localStorage.getItem("user")) {
    next();
  } else {
    next("/login");
  }
});

export default router;
